export const speningOn = () => {
  return {
    type: 'SPENING',
    data: true,
  };
};

export const speningOff = () => {
  return {
    type: 'SPENING',
    data: false,
  };
};
